import { TableCell } from "@mui/material";
import GenericSelect from "../../../../../common/GenericSelect";

const SelectCell = ({ value, onChangeHandler, options }) => {
  return (
    <TableCell align="center">
      <GenericSelect
        className="w-full"
        value={value}
        onChange={onChangeHandler}
        options={options}
      />
    </TableCell>
  );
};

export default SelectCell;
